
import Component from 'vue-class-component';
import {
  PracticesClient,
  InlandVesselPracticeDetailsModel
} from "@/api-client";
import {Prop} from "vue-property-decorator";
import PracticePeriodsTable from "@/features/documents/practices/components/PracticePeriodsTable.vue";
import HarbourVisitsTable from "@/features/documents/practices/components/HarbourVisitsTable.vue";
import Files from "@/components/Files.vue";
import PracticeDetailsContentBase from "@/features/documents/practices/components/PracticeDetailsContentBase";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";

@Component({
  components: {
    HeadingGroup,
    PracticePeriodsTable,
    HarbourVisitsTable,
    Files
  },
})
export default class PracticeInlandVesselDetailsContent extends PracticeDetailsContentBase {
  @Prop()
  details!: InlandVesselPracticeDetailsModel;
  @Prop()
  isOfficial?: boolean;
  
  async getDownloadUrl(fileId: string): Promise<string> {
    return (await new PracticesClient().downloadInlandVesselFile(this.details.id, fileId)).url;
  }
}
